'use strict';

// L'ordine e' quello dello screen-set. Con un data-rule sui <label>
// l'abbinamento diventa esplicito e sopravvive a un riordino.
const REGOLE = [
	{ chiave: 'length', prova: function (v) { return v.length >= 8 && v.length <= 32; } },
	{ chiave: 'upper', prova: function (v) { return /[A-Z]/.test(v); } },
	{ chiave: 'lower', prova: function (v) { return /[a-z]/.test(v); } },
	// "speciale" = non alfanumerico, come i character groups di Gigya
	{ chiave: 'special', prova: function (v) { return /[^A-Za-z0-9]/.test(v); } }
];

function nodeToMove(el) {
	return el.closest('.gigya-composite-control') || el;
}

function prima(a, b) {
	return Boolean(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING);
}

function wrap(nodi) {
	const esistente = nodi[0].closest('.lvz-gigya-password-rules');
	if (esistente) {
		return esistente;
	}
	const box = document.createElement('div');
	box.className = 'lvz-gigya-password-rules';
	const primo = nodeToMove(nodi[0]);
	primo.parentNode.insertBefore(box, primo);
	nodi.forEach(function (n) { box.appendChild(nodeToMove(n)); });
	return box;
}

function passwordRules(root) {
	if (!root) {
		return null;
	}

	const campo = root.querySelector('input[name="newPassword"]')
		|| root.querySelector('.gigya-composite-control-password input[type="password"]')
		|| root.querySelector('input[name="password"]')
		|| root.querySelector('input[type="password"]');
	const voci = Array.prototype.slice.call(root.querySelectorAll('.lvz-gigya-password-required-item'));
	if (!campo || !voci.length) {
		return null;
	}

	// Un gruppo per ogni titolo "Your password must contain", legato all'ultima
	// password prima del titolo (reset: nuova password + conferma).
	const titoli = Array.prototype.slice.call(root.querySelectorAll('.lvz-gigya-password-requirement-title'));
	const password = Array.prototype.slice.call(root.querySelectorAll('input[type="password"]'));
	const gruppi = (titoli.length ? titoli : [null]).map(function (titolo, i) {
		const proprie = voci.filter(function (v) {
			return titoli.length < 2 || (prima(titolo, v) && (!titoli[i + 1] || prima(v, titoli[i + 1])));
		});
		const legate = proprie.map(function (v, k) {
			const chiave = v.getAttribute('data-rule');
			const regola = REGOLE.filter(function (r) { return r.chiave === chiave; })[0] || REGOLE[k];
			return { el: v, prova: regola && regola.prova, stato: undefined };
		}).filter(function (l) { return l.prova; });
		const suoCampo = i === 0 ? campo : password.filter(function (p) { return prima(p, titolo); }).pop() || campo;
		return { campo: suoCampo, legate: legate, nodi: (titolo ? [titolo] : []).concat(proprie), toccato: false };
	}).filter(function (g) { return g.legate.length; });

	if (!gruppi.length) {
		return null;
	}

	// Solo dopo aver trovato regole da legare: evita di marcarsi "bound"
	// su un primo load senza voci (es. screen senza password rules).
	if (campo.getAttribute('data-lvz-bound') === '1') {
		return campo._lvzPasswordRules || null;
	}
	campo.setAttribute('data-lvz-bound', '1');

	function aggiorna(g) {
		const valore = g.campo.value || '';
		// A form appena aperto le voci restano neutre, non tutte rosse.
		const neutro = !g.toccato && !valore;
		g.legate.forEach(function (v) {
			const nuovo = neutro ? null : v.prova(valore);
			if (nuovo === v.stato) return;   // niente scrittura, niente ricalcolo di stile
			v.stato = nuovo;
			v.el.classList.toggle('is-valid', nuovo === true);
			v.el.classList.toggle('is-invalid', nuovo === false);
		});
	}

	function errore(g) {
		const valore = g.campo.value || '';
		return Boolean(valore) && !g.legate.every(function (v) { return v.prova(valore); });
	}

	// Con un elenco: visibile col focus sul campo; fuori dal campo resta aperto
	// solo se la password non rispetta i requisiti.
	// Con piu' campi: elenco del campo attivo, elenchi con errori e, finche' e'
	// vuota, quello della nuova password se nessun campo e' attivo.
	let attivo = null;
	function mostra() {
		if (gruppi.length < 2) {
			const unico = gruppi[0];
			const nonValida = errore(unico) || !unico.campo.value;
			unico.box.classList.toggle('is-open', unico === attivo || (unico.toccato && nonValida));
			return;
		}
		gruppi.forEach(function (g, i) {
			const iniziale = i === 0 && !attivo && !g.campo.value;
			g.box.hidden = !(g === attivo || errore(g) || iniziale);
		});
	}

	gruppi.forEach(function (g) {
		g.box = wrap(g.nodi);
		g.campo.addEventListener('focus', function () { attivo = g; mostra(); });
		g.campo.addEventListener('input', function () { g.toccato = true; aggiorna(g); });
		g.campo.addEventListener('blur', function () { g.toccato = true; aggiorna(g); attivo = null; mostra(); });
		aggiorna(g);
	});
	mostra();

	const api = {
		// La validita' e' quella della nuova password; la conferma la verifica Gigya.
		isValid: function () {
			const valore = gruppi[0].campo.value || '';
			return gruppi[0].legate.every(function (v) { return v.prova(valore); });
		},
		markTouched: function () {
			gruppi.forEach(function (g) { g.toccato = true; aggiorna(g); });
			mostra();
		}
	};
	campo._lvzPasswordRules = api;
	return api;
}

module.exports = passwordRules;
